import { render, staticRenderFns } from "./AcceptRefuseSample.vue?vue&type=template&id=6d15e843&"
import script from "./AcceptRefuseSample.vue?vue&type=script&lang=js&"
export * from "./AcceptRefuseSample.vue?vue&type=script&lang=js&"
import style0 from "./AcceptRefuseSample.vue?vue&type=style&index=0&id=6d15e843&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports